module.exports = __webpack_public_path__ + "static/media/om.aa68baf3.svg";